import AdminHeader from "../../component/AdminHeader";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useEffect, useState } from "react";

export default function Dashboard() {

    const leadsEndpoint = ApiEndpoints.dashboard.dashboardcount;
    const MonthlyEndpoint = ApiEndpoints.dashboard.monthlycount;
    const [loading, setLoading] = useState(true);
    const [leadsCount, setLeadsCount] = useState(

        {
            "newsletter_count": "",
            "blog_count": "",
            "contact_count": "",
            "homeform_count": "",

        }
    );
    const [filter, setFilter] = useState({ type: "", month: "" });
    const currentYear = new Date().getFullYear();
    const getLeadsCount = async () => {
        try {
            setLoading(true);
            const response = await ApiRequest("GET", leadsEndpoint);
            setLeadsCount(response);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching leads count:", error);
        }
    }

    //   Get Montly Count APi
    const getMonthlyCount = async (type, month, varType) => {
        try {
            setLoading(true);
            const response = await ApiRequest("GET", `${MonthlyEndpoint}${varType}/${month}/${currentYear}`);
            setLeadsCount(prev => ({
                ...prev,
                [type]: response.data.Count
            }));
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Monthly count Data:", error);
        }
    }

    useEffect(() => {
        getLeadsCount();

    }, [])
    const handleMonthChange = (e, type, varType) => {
        const selectedMonth = e.target.value;
        getMonthlyCount(type, selectedMonth, varType);

    };
    const pagename = {
        name: 'Dashboard',
        user: 'Admin',
        innerpage: 'Dashboard'
    }

    return (
        <>
            <AdminHeader pagename={pagename} />

            <div className="add-btn-section">
                <div className="row">
                    <div class="col-lg-4">
                        <div class="home-dashbox pink-card">
                            <div class="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select onChange={(e) => handleMonthChange(e, "contact_count", "contact")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href=""><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.contact_count} </h4>
                            <div class="dashbox-link">
                                <p>Contact Us</p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox purple-card">
                            <div class="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select onChange={(e) => handleMonthChange(e, "newsletter_count", "newsletter")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href=""><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.newsletter_count} </h4>
                            <div class="dashbox-link">
                                <p>Newsletter</p>
                                <Link to="newsletter">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox orange-card">
                            <div class="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select onChange={(e) => handleMonthChange(e, "blog_count", "aiblog")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href=""><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.blog_count}</h4>
                            <div class="dashbox-link">
                                <p>Blog</p>
                                <Link to="blog">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox green-card">
                            <div class="dashbox-month">
                                <span>Total Leads</span>
                                <div>
                                    <select onChange={(e) => handleMonthChange(e, "homeform_count", "homeform")}>
                                        <option hidden="" value="">Monthly</option>
                                        <option value="January">January</option>
                                        <option value="February">February</option>
                                        <option value="March">March</option>
                                        <option value="April">April</option>
                                        <option value="May">May</option>
                                        <option value="June">June</option>
                                        <option value="July">July</option>
                                        <option value="August">August</option>
                                        <option value="September">September</option>
                                        <option value="October">October</option>
                                        <option value="November">November</option>
                                        <option value="December">December</option>
                                    </select>
                                    <a href=""><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount.homeform_count}</h4>
                            <div class="dashbox-link">
                                <p>Home Contact</p>
                                <Link to="home-contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    {/* <div class="col-lg-4">
              <div class="home-dashbox grey-card">
                  <div class="dashbox-month">
                      <span>Total Leads</span>
                      <div>
                          <select>
                              <option hidden="" value="">Monthly</option>
                              <option value="January">January</option>
                              <option value="February">February</option>
                              <option value="March">March</option>
                              <option value="April">April</option>
                              <option value="May">May</option>
                          </select>
                          <a href=""><Icons name="rotateRight" /></a>
                      </div>
                  </div>
                  <h4>110</h4>
                  <div class="dashbox-link">
                      <p>Blog</p>
                      <Link to="blog">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div> */}
                </div>
            </div>
        </>
    )
}
